/**
 * SOD-RENDER-1 Unit 1 (recut) — shared self-approval disclosure.
 *
 * Hard requirement, not a preference: renders ONLY a server-provided
 * `selfApproved` flag. Never infers self-approval from comparing actor ids
 * client-side — the backend is authoritative (DTO-GAPS-1 / #475: a decision
 * is self-approval when the decider IS the submitter, computed once,
 * server-side, the same way on every surface). A `selfApproved` of
 * `undefined` (field absent on this response shape) renders nothing, same
 * as `false` — silence, not a guess.
 */
import React from 'react';

export type SelfApprovedBadgeProps = {
  /** Server-provided flag only. `undefined` and `false` both render nothing. */
  selfApproved: boolean | null | undefined;
  /** Optional test id suffix so callers can target a specific row. */
  testIdSuffix?: string;
};

export function SelfApprovedBadge({
  selfApproved,
  testIdSuffix,
}: SelfApprovedBadgeProps): JSX.Element | null {
  if (selfApproved !== true) return null;
  return (
    <span
      className="text-xs text-neutral-500"
      data-testid={testIdSuffix ? `self-approved-${testIdSuffix}` : 'self-approved'}
    >
      Self-approved (no separate approver)
    </span>
  );
}
